import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { EntityOrderedRequestParameters, EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { NotaOperacaoGarantida } from "src/app/model/nota.model";
import Utils from "src/app/shared/fgi-utils";
import { NotasService } from "../../notas.service";
import { FileUtilsService } from "src/app/shared/file-utils.service";

@Component({
    selector: 'app-notas-listagem',
    templateUrl: './notas-listagem.component.html',
    styleUrls: ['./notas-listagem.component.scss'],
    standalone: false
})
export class NotasListagemComponent {
  private agentesFinanceiros: AgenteFinanceiro[] = [];
  //private dataHoraResultado: string;
  private opcoesPaginacao: number[] = [10, 15, 20];
  private atributosOrdenacao: EntityOrderedRequestParameters;

  @Input() notas:NotaOperacaoGarantida[];
  @Input() dataHoraResultado: String;
  @Input() podeCadastrarNota:boolean;
  @Input() atributosPaginacao: EntityPagedRequestParameters;
  @Output() aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  @Output() aoRequererDesativacao: EventEmitter<NotaOperacaoGarantida> = new EventEmitter<NotaOperacaoGarantida>();

  constructor(
    private fileUtils: FileUtilsService,
    private service: NotasService,
    private activatedRoute: ActivatedRoute,) {

    this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes']; //resolver
  }

  ngOnInit() {
    if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
  }

  exportarAnexo(nota: NotaOperacaoGarantida) {
    this.service.getAnexo(nota.id).subscribe((conteudo) => {
        this.fileUtils.exportarArquivo(nota.nomeAnexo, conteudo, FileUtilsService.APPLICATION_OCTEC);
    });
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
      this.notas = this.notas.sort((a, b) => {
        if (ord.sentido == "asc") {
            return Utils.compara(a, b, ord.atributo);
        }
        else {
            return -1 * Utils.compara(a, b, ord.atributo);
        }
        });
  }

  nomeAgenteFinanceiro(id:number){
    return Utils.nomeAgentePorId(id, this.agentesFinanceiros);
  }
  
  reduzirMensagemNota(nota:NotaOperacaoGarantida,tamanho:number):string{
    return nota.mensagem.length>tamanho ? nota.mensagem.slice(0,tamanho)+'...' : nota.mensagem;
  }

  desativar(nota: NotaOperacaoGarantida) {
    this.aoRequererDesativacao.emit(nota);
  }
}